import { BrowserRouter } from 'react-router-dom'
import { I18nProvider } from './i18n/I18nProvider'
import { ChatBotProvider } from './contexts/ChatBotContext'
import { LanguageRouter } from './components/LanguageRouter'
import { CookieBanner } from './components/CookieBanner'
import { ChatBot } from './components/ChatBot'
import { WebVitals } from './components/WebVitals'

function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <ChatBotProvider>
          <WebVitals />
          <LanguageRouter />
          <CookieBanner />
          <ChatBot />
        </ChatBotProvider>
      </I18nProvider>
    </BrowserRouter>
  )
}

export default App
